module.exports = __webpack_public_path__ + "static/media/icon-heart-active.3521ff10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-heart-active.svg
// module id = 520
// module chunks = 0